import styled from 'styled-components';
import { observer } from 'mobx-react-lite';

import Input from 'shared/elements/Input';
import TextArea from 'shared/elements/TextArea';
import DropDown from 'shared/forms/FormDropDown';
import DropDownMulti from 'shared/forms/FormDropDownMulti';

import { useStore } from 'models/stores';
import Field from './Field';
import Upload from './Upload';
import UploadAnother from './UploadAnother';

export default observer(({ question, disabled }) => {
  const {
    uiStore: { t },
  } = useStore();
  return (
    <Field
      required={question.required}
      label={question.title}
      center={question.type === 'one_line'}
    >
      {question.type === 'one_line' && (
        <Input
          value={question.value || ''}
          onChange={(e) => question.setValue(e.target.value)}
          error={question.error && t(question.error)}
          disabled={disabled}
        />
      )}
      {question.type === 'attachment' && !question.multiple && (
        <Upload
          file={question.value || null}
          onChange={question.setValue}
          disabled={disabled}
          error={question.error && t(question.error)}
        />
      )}
      {question.type === 'attachment' && question.multiple && (
        <>
          {(!question.value || question.value.length === 0) && (
            <Upload
              file={null}
              onChange={question.setValue}
              disabled={disabled}
              error={question.error && t(question.error)}
            />
          )}
          {question.value && question.value.length > 0 && (
            <>
              {question.value.map((v, index) => (
                <UploadContainer key={index} first={index === 0}>
                  <Upload
                    file={v || null}
                    onChange={(value) => question.setValue(value, index)}
                    disabled={disabled}
                    error={question.error && t(question.error)}
                  />
                </UploadContainer>
              ))}
              <UploadAnother
                onChange={question.setValue}
                disabled={disabled}
                error={question.error && t(question.error)}
              />
            </>
          )}
        </>
      )}
      {question.type === 'multi_line' && (
        <TextArea
          resize
          value={question.value}
          onChange={(e) => question.setValue(e.target.value)}
          error={question.error && t(question.error)}
          disabled={disabled}
        />
      )}
      {question.type === 'dropdown' && (
        <DropDown
          items={question.options}
          onChange={question.setValue}
          error={question.error && t(question.error)}
          disable={disabled}
        />
      )}

      {question.type === 'multidropdown' && (
        <DropDownMulti
          items={question.options}
          onChange={question.setValue}
          error={question.error && t(question.error)}
          disable={disabled}
        />
      )}
    </Field>
  );
});

const UploadContainer = styled.div`
  margin-top: ${(p) => (p.first ? 0 : '8px')};
`;
